import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { DataMaterialsService } from '@components/materials/data-materials.service';
import { getEvent } from '@custom-types/event';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { ModelsToolsService } from '@providers/models-tools/models-tools.service';
import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';
var DashboardComponent = /** @class */ (function () {
    function DashboardComponent(router, globalDataService, requestService, requestV2Service, modelsToolsService, dataMaterialsService) {
        var _this = this;
        this.router = router;
        this.globalDataService = globalDataService;
        this.requestService = requestService;
        this.requestV2Service = requestV2Service;
        this.modelsToolsService = modelsToolsService;
        this.dataMaterialsService = dataMaterialsService;
        this.notifications = [];
        this.globalDataService.getCurrentProject().subscribe(function (project) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var notificationsResults;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.project = project;
                        this.notifications = [];
                        if (project == null || !this.dataMaterialsService.refreshData) {
                            return [2 /*return*/];
                        }
                        this.fillEvents();
                        return [4 /*yield*/, this.requestV2Service.getNotifications(project.id)];
                    case 1:
                        notificationsResults = _a.sent();
                        if (notificationsResults.items) {
                            this.notifications = notificationsResults.items.map(function (item) {
                                var notification = {
                                    caption: item.email.subject,
                                    href: '#'
                                };
                                if (item.label.includes('file')) {
                                    notification.href = "/project/" + _this.project.id + "/files";
                                }
                                else if (item.label.includes('quotation')) {
                                    notification.href = "/project/" + _this.project.id + "/quotations";
                                }
                                return notification;
                            });
                        }
                        this.dataMaterialsService.currentProject = project;
                        return [4 /*yield*/, this.dataMaterialsService.computeProjectMaterialsData()];
                    case 2:
                        _a.sent();
                        this.dataMaterialsService.refreshData = false;
                        return [2 /*return*/];
                }
            });
        }); });
    }
    DashboardComponent.prototype.fillEvents = function () {
        var _this = this;
        this.events = [];
        Object.keys(this.project.dates).forEach(function (key) {
            var event = getEvent(key, _this.project.dates[key]);
            if (event === null) {
                return;
            }
            if (!_this.eventToAdd(event)) {
                return;
            }
            _this.events.push(event);
        });
        // Si date recalée supprimer le reste
        var endWorkIndex = this.events.map(function (item) { return item.type; }).indexOf('finalEndWork');
        if (endWorkIndex !== -1) {
            var expectedIndex_1 = this.events.map(function (item) { return item.type; }).indexOf('endProject');
            var contractIndex_1 = this.events.map(function (item) { return item.type; }).indexOf('endWork');
            if (expectedIndex_1 !== -1) {
                this.events.splice(expectedIndex_1, 1);
            }
            if (contractIndex_1 !== -1) {
                this.events.splice(contractIndex_1, 1);
            }
        }
        // Si dates contractuelles supprimer les autres
        var contractIndex = this.events.map(function (item) { return item.type; }).indexOf('endWork');
        if (contractIndex !== -1) {
            var endWorkIndex_1 = this.events.map(function (item) { return item.type; }).indexOf('finalEndWork');
            var expectedIndex_2 = this.events.map(function (item) { return item.type; }).indexOf('endProject');
            if (endWorkIndex_1 !== -1) {
                this.events.splice(endWorkIndex_1, 1);
            }
            if (expectedIndex_2 !== -1) {
                this.events.splice(expectedIndex_2, 1);
            }
        }
        var expectedIndex = this.events.map(function (item) { return item.type; }).indexOf('endProject');
        if (expectedIndex !== -1) {
            var endWorkIndex_2 = this.events.map(function (item) { return item.type; }).indexOf('finalEndWork');
            var contractIndex_2 = this.events.map(function (item) { return item.type; }).indexOf('endWork');
            if (endWorkIndex_2 !== -1) {
                this.events.splice(endWorkIndex_2, 1);
            }
            if (contractIndex_2 !== -1) {
                this.events.splice(contractIndex_2, 1);
            }
        }
        if (!this.modelsToolsService.isDesignStep(this.project._related.steps[0].id)) {
            var progressEvent = {
                label: "Avancement planning : " + this.getProgress(this.project.progress),
                date: '',
                type: 'progress'
            };
            this.events.push(progressEvent);
        }
    };
    DashboardComponent.prototype.isDesignStep = function () {
        return this.project.step === 'agreement_signed' || this.project.step === 'contract_sent';
    };
    DashboardComponent.prototype.eventToAdd = function (event) {
        if (this.isDesignStep()) {
            switch (event.type) {
                case 'materialsCheck':
                case 'contractSign':
                case 'startProject':
                case 'endProject':
                    return true;
                default:
                    return false;
            }
        }
        switch (event.type) {
            case 'startWork':
            case 'endWork':
            case 'finalEndWork':
                return true;
            default:
                return false;
        }
    };
    DashboardComponent.prototype.getProgress = function (progress) {
        switch (progress) {
            case 'compliant':
                return 'Conforme';
            case 'minor':
                return 'Retard mineur';
            case 'critical':
                return 'Retard critique';
        }
    };
    DashboardComponent.prototype.onNavigateTo = function () {
        var target = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            target[_i] = arguments[_i];
        }
        this.router.navigate(tslib_1.__spread(['projects', this.project.id], target));
    };
    DashboardComponent.prototype.checkStep = function () {
        var _this = this;
        if (this.project && this.globalDataService.steps) {
            var currentStep = this.globalDataService.steps
                .find(function (s) { return s.id === _this.project.id_project_step; });
            if (currentStep) {
                return !this.globalDataService.checkStepIsBefore(currentStep.slug, 'handoff_meeting');
            }
            return false;
        }
        return false;
    };
    return DashboardComponent;
}());
export { DashboardComponent };
